module.exports = __webpack_public_path__ + "media/images/social/in-dark-8cd68feb9af97e79809942cfb1140d05.svg";